import { render } from "./leads-notes.vue?vue&type=template&id=d77fba90"
import script from "./leads-notes.vue?vue&type=script&lang=js"
export * from "./leads-notes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__